function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
export const Heading = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Box, _extends({
  ref: ref,
  as: "h2",
  tx: "text"
}, props, {
  __css: {
    fontSize: 4,
    color: 'heading',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading'
  }
})));
Heading.displayName = 'Heading';
export default Heading;